import { render, staticRenderFns } from "./ModalLicenceDetails.vue?vue&type=template&id=a173a3dc&scoped=true&"
import script from "./ModalLicenceDetails.vue?vue&type=script&lang=js&"
export * from "./ModalLicenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenceDetails.vue?vue&type=style&index=0&id=a173a3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a173a3dc",
  null
  
)

export default component.exports